// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLuckyCanvas from '@lucky-canvas/vue';
import common from "./lib/requestConf/common";
import vantComponents from '../vant.config' // 引入vant
import VueWechatTitle from 'vue-wechat-title'
// 引入腾讯地图API
// import TMap from 'TMap'
// window.TMap = TMap;

Vue.config.productionTip = false
Vue.use(VueLuckyCanvas)
Vue.use(common)
Vue.use(vantComponents);
Vue.use(VueWechatTitle)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js